import { MainContext } from "components/utils/Contexts";
import { useContext } from "react";

interface TabBarProps {
  options: string[];
  selectedTab: number;
  handleClickTab: (index: number) => void;
}

const TabBar: React.FC<TabBarProps> = ({
  options,
  selectedTab,
  handleClickTab,
}) => {
  // Get the context parameters
  const { userRole } = useContext(MainContext);

  return (
    <>
      {["master admin", "customer admin", "class admin"].includes(userRole) && (
        <div className="w-full h-[59px] flex-col justify-center items-center gap-2 inline-flex mt-4 mb-2">
          <div className="p-1.5 bg-neutral-100 rounded-full justify-start items-center gap-1.5 inline-flex">
            {options.map((option, index) => (
              <div
                key={index}
                className={`px-6 py-3 rounded-full justify-center items-center gap-2 flex cursor-pointer ${
                  selectedTab === index
                    ? "bg-white"
                    : "hover:bg-neutral-200 ease-in-out duration-150"
                }`}
                onClick={() => handleClickTab(index)}
              >
                <div className="text-[19px] font-semibold font-sans leading-[23px] text-secondary-600 select-none">
                  {option}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default TabBar;
